<!--
  -  Author: Raul Perusquia <raul@inikoo.com>
  -  Created: Thu, 11 Aug 2022 11:08:49 Malaysia Time, Kuala Lumpur, Malaysia
  -  Reformatted: Fri, 03 Mar 2023 12:40:58 Malaysia Time, Kuala Lumpur, Malaysia
  -  Copyright (c) 2022, Inikoo
  -  Version 4.0
  -->


<script setup lang="ts">
import { ref, provide, defineAsyncComponent } from 'vue'
import { initialiseApp } from "@/Composables/initialiseApp"
// import { usePage } from "@inertiajs/vue3"
// import Footer from "@/Components/Footer/Footer.vue"

import { useLayoutStore } from "@/Stores/layout"
import { useLocaleStore } from "@/Stores/locale"

import '@vuepic/vue-datepicker/dist/main.css'

import TopBar from "@/Layouts/Grp/TopBar.vue"
import LeftSideBar from "@/Layouts/Grp/LeftSideBar.vue"
import RightSideBar from "@/Layouts/Grp/RightSideBar.vue"
// import StackedComponents from "@/Layouts/Grp/StackedComponents.vue"
// import Breadcrumbs from "@/Components/Navigation/Breadcrumbs.vue"
import Notification from '@/Components/Utils/Notification.vue'
import { faTachometerAltFast, faListUl, faShapes, faSackDollar, faDotCircle, faTrashAlt, faUndoAlt, faInfoCircle, faSkull, faRocketLaunch, faUserCheck, faHourglassHalf, faCommentAlt, faCommentAltExclamation, faListOl, faPrint, faUndo } from '@fal'
import { faSearch, faBell } from '@far'
import { faServer as fadServer } from '@fad'
import { faLayerGroup, faCheckCircle, faStickyNote, faLock, faFile, faExclamationTriangle as falExclamationTriangle, faSync, faTruck, faCashRegister, faAlbum, faSensor, faBox, faPencil, faPlay, faClock, faHomeAlt, faCog, faSignOut, faShredder, faBoxes, faFileInvoiceDollar, faServer, faBuilding, faTimes, faTimesCircle } from '@fal'
import { faSquare, faCircle, faTriangle, faSkull as fasSkull, faExclamationTriangle, faSackDollar as fasSackDollar } from '@fas'  // Product Type
import { library } from '@fortawesome/fontawesome-svg-core'
import RetinaEcomLeftSidebar from './Grp/RetinaEcomLeftSidebar.vue'
import { Link } from '@inertiajs/vue3'
import MenuTopRight from './Grp/MenuTopRight.vue'
import LoadingIcon from '@/Components/Utils/LoadingIcon.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { notify } from '@kyvg/vue3-notification'
import ScreenWarning from '@/Components/Utils/ScreenWarning.vue'
library.add(fadServer, faLayerGroup, faCheckCircle, faStickyNote, faLock, faFile, faExclamationTriangle, fasSackDollar, falExclamationTriangle, faSync, faTruck, faCashRegister, faAlbum, faSensor, faBox, faPencil, faPlay, faClock, faHomeAlt, faCog, faSignOut, faShredder, faBoxes, faFileInvoiceDollar, faServer, faBuilding, faTimes, faTimesCircle, faSquare, faCircle, faTriangle, faSearch, faBell, faTachometerAltFast, faListUl, faShapes, faSackDollar, faDotCircle, faTrashAlt, faUndoAlt, faInfoCircle, faSkull, faRocketLaunch, faUserCheck, faHourglassHalf, faCommentAlt, faCommentAltExclamation, faListOl, faPrint, faUndo, fasSkull, faExclamationTriangle)

provide('layout', useLayoutStore())
provide('locale', useLocaleStore())

initialiseApp()



const layout = useLayoutStore()
const isSidebarOpen = ref(false)
provide('isSidebarOpen', isSidebarOpen)

const isLoadingLogout = ref<string|null>(null)

const abc = () => {
    notify({
        title: 'dsadsadsa',
        text: 'vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv',
        type: 'success',
    })
}
</script>

<template>
    <div class="relative py-14 p-4 md:p-12 md:flex gap-x-8 min-h-screen transition-all duration-200 ease-in-out"
        :class="[Object.values(layout.rightSidebar).some(value => value.show) ? 'mr-44' : 'mr-0']">

        <TopBar
            :sidebarOpen="isSidebarOpen"
            logoRoute="dashboard"
            urlPrefix="grp."
        />

        <!-- Button: Hamburger -->
        <button class="md:hidden absolute top-5 right-6 z-30 p-2 rounded-lg shadow text-white" @click="isSidebarOpen = !isSidebarOpen">
            <div class="block w-7 absolute left-1/2 top-1/2   transform  -translate-x-1/2 -translate-y-1/2">
                <span
                    aria-hidden="true"
                    class="block absolute rounded-full h-[2px] w-7 transform transition-all"
                    :class="isSidebarOpen ? 'rotate-45 bg-white' : '-translate-y-1.5 bg-gray-900'"
                />
                <span
                    aria-hidden="true"
                    class="block absolute rounded-full h-[2px] w-7 bg-gray-900 transform transition duration-100 ease-in-out"
                    :class="isSidebarOpen ? 'opacity-0' : 'opacity-100'"
                />
                <span
                    aria-hidden="true"
                    class="block absolute rounded-full h-[2px] w-7 bg-gray-900 transform transition-all"
                    :class="isSidebarOpen ? '-rotate-45 bg-white' : 'translate-y-1.5 bg-gray-900'"
                />
            </div>
        </button>

        <!-- Helper: black background on mobile -->
        <Transition>
            <div
                v-if="isSidebarOpen"
                @click="() => isSidebarOpen = false"
                class="left-0 top-0 fixed w-screen h-screen bg-black/40 z-[22]"
            />
        </Transition>

        <!-- Sidebar: Left navigation -->
        <div class="z-[23] block absolute md:static max-w-64 w-full transition-all ease-in-out duration-150"
            :class="isSidebarOpen ? 'left-12' : '-left-64 md:left-12'"
        >
            <RetinaEcomLeftSidebar />
                                
            <div class="mt-6 md:mt-2">
                <div class="flex flex-col gap-2 bg-primary md:bg-transparent rounded-md px-2 md:px-0 py-3">
                    <Link
                        :href="route('profile.edit')"
                        as="a"
                        class="w-full flex items-center gap-2 hover:bg-primary/20 text-white md:text-primary px-2 py-1 rounded cursor-pointer"
                        :class="{ 'bg-primary/20 font-semibold': route().current('profile.edit') }"
                        @start="() => isLoadingLogout = 'profile'"
                        @finish="() => isLoadingLogout = null"
                    >
                        <LoadingIcon v-if="isLoadingLogout === 'profile'" class='opacity-50' />
                        <FontAwesomeIcon v-else icon='fal fa-cog' class='opacity-50' fixed-width aria-hidden='true' />
                        Pengaturan
                    </Link>

                    <Link
                        :href="route('auth.logout')"
                        as="a"
                        class="w-full flex items-center gap-2 hover:bg-red-600/20 text-red-600 px-2 py-1 rounded cursor-pointer"
                        @start="() => isLoadingLogout = 'logout'"
                        @error="() => isLoadingLogout = null"
                    >
                        <LoadingIcon v-if="isLoadingLogout === 'logout'" class='opacity-50' />
                        <FontAwesomeIcon v-else icon='fal fa-sign-out' class='xopacity-50' fixed-width aria-hidden='true' />
                        Logout
                    </Link>
                </div>
            </div>
        </div>

        <!-- Main Content -->
        <main
            class="max-w-7xl pb-8 w-full xmx-auto bg-white rounded shadow-lg h-full relative xoverflow-y-auto"
            xclass="[
                layout.leftSidebar.show ? 'ml-0 md:ml-48' : 'ml-0 md:ml-12',
                layout.app.environment === 'staging' ? 'mt-6' : ''
            ]">
            <div class="z-[22] absolute -top-11 left-40 md:left-0">
                <!-- Section: Dropdown + subsections -->
                <div class="flex items-center gap-x-2 pl-2 xqwezxc md:mt-2">

                    <!-- Section: Subsections (Something will teleport to this section) -->
                    <div class="flex h-full" id="TopBarSubsections">
                    </div>

                </div>
            </div>

            <slot />
        </main>

        <ScreenWarning v-if="layout.app.environment === 'staging'" />


        <!-- Sidebar: Right -->
        <!-- <RightSideBar class="fixed top-16 w-44 transition-all duration-200 ease-in-out"
            :class="[Object.values(layout.rightSidebar).some(value => value.show) ? 'right-0' : '-right-44']" /> -->

        <!-- <Teleport to="body">
            <Transition name="stacked-component">
                <StackedComponents v-if="layout.stackedComponents?.length" />
            </Transition>
        </Teleport> -->

    </div>

    <!-- <div class="w-64 h-10" @click="abc">vvvvvvvvvvvvv</div> -->

    <!-- Global declaration: Notification -->
    <notifications
        dangerously-set-inner-html
        :max="3"
        width="500"
        classes="custom-style-notification"
        :pauseOnHover="true"
    >
        <template #body="props">
            <Notification :notification="props" />
        </template>
    </notifications>
</template>

<style lang="scss">
// * {
//     --color-primary: v-bind('layout.app.theme[0]');
// }

/* Navigation: Aiku */
.navigationActive {
    @apply rounded py-2 font-semibold transition-all duration-0 ease-out;
    // border: v-bind('`1px solid color-mix(in srgb, ${layout?.app?.theme[2]} 85%, black)`') !important;
    box-shadow: v-bind('`0 0 0 1px color-mix(in srgb, ${layout?.app?.theme[2]}, 20% white)`') !important;
    background-color: v-bind('layout?.app?.theme[2]');
    color: v-bind('layout?.app?.theme[3]')
}
.navigation {
    @apply hover:bg-gray-300/40 py-2 rounded font-semibold transition-all duration-0 ease-out;
    color: v-bind('layout?.app?.theme[1]')
}

.subNavActive {
    @apply bg-indigo-200/20 sm:border-l-4 sm:border-indigo-100 text-white font-semibold transition-all duration-0 ease-in-out;
}
.subNav {
    @apply hover:bg-white/80 text-gray-100 hover:text-indigo-500 font-semibold transition-all duration-0 ease-in-out
}

.navigationSecondActive {
    @apply transition-all duration-100 ease-in-out;
}
.navigationSecond {
    @apply hover:bg-gray-100 text-gray-400 hover:text-gray-500 transition-all duration-100 ease-in-out
}

.bottomNavigationActive {
    @apply w-5/6 absolute h-0.5 rounded-full bottom-0 left-[50%] translate-x-[-50%] mx-auto transition-all duration-200 ease-in-out;
    background-color: v-bind('layout.app.theme[4]');
}
.bottomNavigation {
    @apply bg-gray-300 w-0 group-hover:w-3/6 absolute h-0.5 rounded-full bottom-0 left-[50%] translate-x-[-50%] mx-auto transition-all duration-200 ease-in-out
}
.bottomNavigationSecondaryActive {
    @apply w-5/6 bg-gray-400 absolute h-0.5 rounded-full bottom-0 left-[50%] translate-x-[-50%] mx-auto transition-all duration-200 ease-in-out;
    
}
.bottomNavigationSecondary {
    @apply bg-gray-200 w-0 group-hover:w-3/6 absolute h-0.5 rounded-full bottom-0 left-[50%] translate-x-[-50%] mx-auto transition-all duration-200 ease-in-out
}

.primaryLink {
    background: v-bind('`linear-gradient(to top, ${layout.app.theme[6]}, ${layout.app.theme[6] + "77"})`');
    &:hover, &:focus {
        color: v-bind('`${layout.app.theme[7]}`');
    }

    @apply focus:ring-0 focus:outline-none focus:border-none
    bg-no-repeat [background-position:0%_100%]
    [background-size:100%_0.2em]
    motion-safe:transition-all motion-safe:duration-200
    hover:[background-size:100%_100%]
    focus:[background-size:100%_100%] px-1 py-0.5
}

.secondaryLink {
    background: v-bind('`linear-gradient(to top, #d1d5db, #e5e7eb)`');
    &:hover, &:focus {
        color: v-bind('`${layout.app.theme[7]}`');
    }

    @apply focus:ring-0 focus:outline-none focus:border-none
    bg-no-repeat [background-position:0%_100%]
    [background-size:100%_0.2em]
    motion-safe:transition-all motion-safe:duration-200
    hover:[background-size:100%_100%]
    focus:[background-size:100%_100%] px-1 py-0.5
}


// For icon box in FlatTreemap
.specialBoxActive {
    background: v-bind('`linear-gradient(to top, ${layout.app.theme[0]}, ${layout.app.theme[0] + "AA"})`');
    color: v-bind('`${layout.app.theme[1]}`');
    border: v-bind('`2px solid ${layout.app.theme[0] + "99"}`') !important;

    @apply rounded overflow-hidden
    cursor-pointer
    focus:ring-0 focus:outline-none
    bg-no-repeat [background-position:0%_100%]
    motion-safe:transition-all motion-safe:duration-100
    [background-size:100%_100%]
    focus:[background-size:100%_100%] px-1;
}
.specialBox {
    background: v-bind('`linear-gradient(to top, ${layout.app.theme[0]}, ${layout.app.theme[0] + "AA"})`');
    color: v-bind('`${layout.app.theme[0]}`');
    border: v-bind('`2px solid ${layout.app.theme[0] + "99"}`') !important;

    &:hover, &:focus {
        color: v-bind('`${layout.app.theme[1]}`');
    }

    @apply rounded overflow-hidden
    cursor-pointer
    focus:ring-0 focus:outline-none
    bg-no-repeat [background-position:0%_100%]
    [background-size:100%_0em]
    motion-safe:transition-all motion-safe:duration-100
    hover:[background-size:100%_100%]
    focus:[background-size:100%_100%] px-1;
}
</style>
